import { makeVar } from '@apollo/client';
import { uniqueId } from 'lodash-es';
import Cookies from 'js-cookie';

export enum AcceptanceState {
  DEFAULT = 'default',
  GRANTED = 'granted',
  DENIED = 'denied',
}

export const deviceOrientationAcceptance = makeVar<AcceptanceState>(
  typeof window.DeviceOrientationEvent?.requestPermission !== 'function'
    ? AcceptanceState.GRANTED
    : Cookies.get('device-orientation-denied') === 'denied'
      ? AcceptanceState.DENIED
      : AcceptanceState.DEFAULT,
);

export const grantDeviceOrientation = () => {
  deviceOrientationAcceptance(AcceptanceState.GRANTED);
};

export const denyDeviceOrientation = () => {
  deviceOrientationAcceptance(AcceptanceState.DENIED);

  Cookies.set('device-orientation-denied', 'denied', {
    expires: 14,
  });
};

interface Notification {
  id: string;
  type: 'notice' | 'alert';
  content: string;
}

export const notifications = makeVar<Notification[]>([]);

export const appendNotification = (options: Omit<Notification, 'id'>) => {
  const notification = { id: uniqueId(), ...options };

  notifications([...notifications(), notification]);

  setTimeout(() => {
    notifications(notifications().filter((n) => n !== notification));
  }, 3000);
};

export const headerHeight = makeVar(0);

export const trialFontsFormVisible = makeVar(false);

export const toggleTrialFontsForm = () => {
  trialFontsFormVisible(!trialFontsFormVisible());
};

export const lastCompletedOrderId = makeVar<number | null>(null);

export const scrolledToConcepts = makeVar(false);

export const checkoutScriptsLoaded = makeVar(false);
